const initPDPModal = (container = document) => {
  const openModalBtns = container.querySelectorAll('[data-pdp-images-modal-opener]');
  if (!openModalBtns) return;

  const dialog = document.querySelector('[data-pdp-images-dialog]');
  const dialogContent = dialog.querySelector('[data-pdp-images-dialog-content]');
  const closeModalBtn = document.querySelector('[data-pdp-images-dialog-close]');
  const swiperEl = dialogContent.querySelector('.pdp-images-modal-swiper');
  const nextEl = dialogContent.querySelector('.swiper-button-next');
  const prevEl = dialogContent.querySelector('.swiper-button-prev');
  const paginationEl = dialogContent.querySelector('.swiper-pagination');
  const mediaQueryList = window.matchMedia("(width < 990px)");

  const isMobile = () => {
    return mediaQueryList.matches;
  }

  const modalClose = () => {
    dialog.close();
    document.body.classList.remove('overflow-hidden');
  };

  closeModalBtn.addEventListener('click', () => {
    modalClose();
  });

  const pdpImagesOpen = (button) => {
    dialog.showModal();
    document.body.classList.add('overflow-hidden');
    const mediaId = button.dataset.mediaId;
    const child = dialogContent.querySelector(`.pdp-images-modal-swiper [data-media-id="${mediaId}"]`);
    const index = (child) ? [...child.parentNode.children].indexOf(child) : 0;
    if(swiperEl && swiperEl.swiper) {
      swiperEl.swiper.destroy();
    }
    const swiper = new Swiper(swiperEl, {
      initialSlide: index,
      slidesPerView: 1,
      centeredSlides: true,
      grabCursor: true,
      loop: false,
      pagination: {
        el: paginationEl,
        clickable: true
      },
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
    });
    trapFocus(dialog,closeModalBtn);
  };

  const initOpenModalBtns = (element) => {
    element.addEventListener('click', (event) => {
      const button = event.target.closest('button');
      pdpImagesOpen(button);
    });
  };

  dialog.addEventListener('keydown', (event) => {
    if (event.key.toUpperCase() === 'ESCAPE') {
      event.preventDefault();
      modalClose();
    }
  });

  openModalBtns.forEach(initOpenModalBtns);
};
initPDPModal();